module.exports = __webpack_public_path__ + "static/media/BP.0a889994.svg";